<template>
  <div class="tableTree">
    <div class="btn-bars clear">
      <div class="left fl">
        <slot name="outsideBtnLeft"></slot>
      </div>
      .
      <div class="right fr">
        <a-button type="gray" @click="tableShow">展开</a-button>
        <a-button type="gray" @click="tableHide" style="margin-left: 8px"
          >收起</a-button
        >
        <slot name="outsideBtnRight"></slot>
      </div>
    </div>
    <a-table
      :columns="columns"
      :data-source="tableData"
      :expanded-row-keys="expandedRowKeys"
      @expandedRowsChange="expandedRowsChange"
      :rowKey="rowKey"
      bordered
      :pagination="false"
    >
      <span slot="id" slot-scope="text">{{ text }}</span>
      <span slot="action" slot-scope="text">
        <slot name="insideBtn" :data="text"></slot>
      </span>
    </a-table>
  </div>
</template>

<script>
export default {
  name: "tableTree",
  data() {
    return {
      expandedRowKeyAll: [],
      expandedRowKeys: [],
    };
  },
  props: ["columns", "tableData", "rowKey"],
  mounted() {
    this.getExpandedRowKeyAll(this.tableData);
    this.tableShow();
  },
  methods: {
    getExpandedRowKeyAll(array) {
      for (let key in array) {
        let data = array[key];
        this.expandedRowKeyAll.push(data.id);
        if (data.children) {
          this.getExpandedRowKeyAll(data.children);
        }
      }
    },
    tableHide() {
      this.expandedRowKeys = [];
    },
    tableShow() {
      this.expandedRowKeys = this.expandedRowKeyAll;
    },
    expandedRowsChange(expandedRows) {
      this.expandedRowKeys = expandedRows;
    },
  },
  watch: {
    tableData: function (val) {
      this.getExpandedRowKeyAll(val);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.fl {
  float: left;
}
.fr {
  float: right;
}
.clear {
  clear: both;
  zoom: 1;
}
.clear:after,
.clear:before {
  content: "";
  display: table;
  height: 0;
  clear: both;
}
.btn-bars {
  margin-bottom: 15px;
}
</style>
